var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"descri",class:_vm.cssClass,domProps:{"innerHTML":_vm._s(_vm.info)}})])}
var staticRenderFns = []

export { render, staticRenderFns }